



























































































import { Component, Vue, Inject, Prop, Ref, Watch } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { User } from '@/data/models/user.model';
import { Offer, ShipmentStatus } from '@/data/models/offer.model';
import RiscossioneList from '@/views/riscossioni/RiscossioneList.vue';
import { OfferService } from '@/data/services/offer.service';
import { debounce } from 'lodash';
import store, { State } from '@/store';
import FattorinoOffer from './FattorinoOffer.vue';
import FattorinoAction from './FattorinoAction.vue';

@Component({
	components: {
		RiscossioneList,
	},
})
export default class FattorinoOfferList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop() fattorino!: User;
	
	@Inject('CrudService') crudService!: CrudService<Offer>;
	@Inject('OfferService') offerService!: OfferService;

	@Ref('list') list!: RiscossioneList;
	@Ref('barcodeinput') barcodeinput!: any;

	rows: Offer[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('offer join contact on offer.contactid = contact.id left join user as u1 on offer.operatorid = u1.id left join user as u2 on offer.deliveryid = u2.id');
	barcodereader: boolean = false;
	barcodevalue: string = '';
	debouncedOnBarcodeChange!: Function;
	disableAcceptAllButton: boolean = true;

	searchParam: any = new class {
		fullname?: string;
	};

	state!: State;

	@Watch('barcodevalue')
	onValueChange(value: string) {
		this.debouncedOnBarcodeChange(value);
	}

	constructor() {
		super();
		this.state = store;
		this.debouncedOnBarcodeChange = debounce(this.onBarcodeAction, 500);
	}

	mounted() {
		this.search();
	}

	onClick({ offer, action }: { offer: Offer; action: string }) {
		if (action === 'editAmount') {
			const modal = this.$buefy.modal.open({
				parent: this,
				component: FattorinoOffer,
				props: {
					model: offer
				},
				hasModalCard: true,
				canCancel: false,
				events: {
					submit: (value: Offer) => {
						this.crudService.saveEntity(Offer, 'offer', value).then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							modal.close();
							this.list.loadData();
						}).catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
					}
				}
			});
		} else if (action === 'not-delivered') {
			this.offerService.setNonConsegnato(offer.id).then(() => {
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.list.loadData();
			}).catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
		} else {
			this.offerService.setEsito(offer.id, action).then(() => {
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.list.loadData();
			}).catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
			this.resetBarcodeValue();
			if (this.barcodereader) this.barcodeinput.focus();
		}
	}

	acceptAll() {
		const loading = this.$buefy.loading.open({});
		this.offerService.acceptAll(ShipmentStatus.DELIVERED, this.fattorino.id).then(() => {
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			this.list.loadData();
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

	resetBarcodeValue() {
		this.barcodevalue = '';
	}

	enableBarCodeReader() {
		this.barcodereader = !this.barcodereader;
		this.barcodeinput.focus();
	}

	onBarcodeAction(value: string) {
		if (!value) return;
		this.crudService.getEntity(Offer, 'offer', Number(value)).then((result: Offer) => {
			if (!result || result && result.shipmentstatus !== ShipmentStatus.ASSIGNED) {
				let message = `${this.$t('codice')} ${this.$t('not-found')}`;

				if (result && result.shipmentstatus !== ShipmentStatus.ASSIGNED) {
					message = `${this.$t('offer-status-different-than')} ${(this.$t('offer-status.assigned') as string).toLowerCase()}`;
				} 

				this.$buefy.notification.open({
					message,
					type: 'is-danger',
				});
				this.resetBarcodeValue();
				this.barcodeinput.focus();
			} else {
				this.showActionDialog(result);
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
			this.resetBarcodeValue();
		});
	}

	showActionDialog(offer: Offer) {
	
		const modal = this.$buefy.modal.open({
			parent: this,
			component: FattorinoAction,
			trapFocus: true,
			hasModalCard: true,
			canCancel: ['x', 'escape'],
			props: {
				offer: offer
			},
			events: {
				'action': (action: string) => {
					this.onClick({ offer, action });
					modal.close();
				}	
			}
		});
	}

	onDataLoad(counter: number) {
		if (counter > 0) this.disableAcceptAllButton = false;
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
		this.advancedSearch.addSimpleFilter('deliveryid', this.fattorino.id);
		this.advancedSearch.addSimpleFilter('shipmentstatus', ShipmentStatus.ASSIGNED);

		if (this.searchParam.fullname) 
			this.advancedSearch.addLikeFilter("concat(contact.name, ' ', coalesce(contact.surname, ''))", this.searchParam.fullname);

		this.list.advancedSearch = this.advancedSearch;
		this.list.loadData();
	}

	reset() {
		this.searchParam.fullname = undefined;
		this.search();
	}

}
